type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

function LogOutIcon({
  width = '16',
  height = '17',
  fillColor = '#F3E9D7',
}: Props = {}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 5.16667L10.3935 6.10667L12.1135 7.83333H5.3335V9.16667H12.1135L10.3935 10.8867L11.3335 11.8333L14.6668 8.5M2.66683 3.83333H8.00016V2.5H2.66683C1.9335 2.5 1.3335 3.1 1.3335 3.83333V13.1667C1.3335 13.9 1.9335 14.5 2.66683 14.5H8.00016V13.1667H2.66683V3.83333Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default LogOutIcon;
